import { render, staticRenderFns } from "./ProductBoxRelated.vue?vue&type=template&id=d4c92ca2&"
import script from "./ProductBoxRelated.vue?vue&type=script&lang=js&"
export * from "./ProductBoxRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports